
import React from 'react';
import { ArrowRight, Clock, Video, Shield, Target, Cpu, Map } from 'lucide-react';

const BookingWidget: React.FC = () => {
    return (
        <div className="w-full max-w-5xl mx-auto">
            <div className="bg-zinc-900 border border-zinc-800 rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden">
                 {/* Subtle gradient accent top right */}
                <div className="absolute top-0 right-0 w-64 h-64 bg-orange-500/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>

                <div className="grid md:grid-cols-2 gap-12 items-start mb-12">
                    {/* Left Side: Pitch */}
                    <div className="text-left space-y-8">
                        <div>
                            <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-orange-500/10 text-orange-400 text-[10px] font-bold uppercase tracking-widest mb-6">
                                <span className="w-1.5 h-1.5 rounded-full bg-orange-500 animate-pulse"></span>
                                Priority Access
                            </div>
                            <h3 className="text-3xl md:text-4xl font-bold text-white tracking-tight mb-4">Revenue Recovery Call</h3>
                            <p className="text-zinc-400 text-lg leading-relaxed">
                                62% of leads hire the first roofer to answer the phone. Let's fix your missed calls.
                            </p>
                        </div>

                        <div className="flex flex-col gap-5 pt-6 border-t border-zinc-800/50">
                            <div className="flex items-center gap-4 text-sm font-medium text-zinc-300">
                                <div className="w-10 h-10 rounded-full bg-zinc-800 flex items-center justify-center text-zinc-400 shrink-0">
                                    <Clock size={18} />
                                </div>
                                <span className="text-base">15 Minute Duration</span>
                            </div>
                            <div className="flex items-center gap-4 text-sm font-medium text-zinc-300">
                                <div className="w-10 h-10 rounded-full bg-zinc-800 flex items-center justify-center text-zinc-400 shrink-0">
                                    <Video size={18} />
                                </div>
                                <span className="text-base">Live Google Meet</span>
                            </div>
                            <div className="flex items-center gap-4 text-sm font-medium text-zinc-300">
                                <div className="w-10 h-10 rounded-full bg-zinc-800 flex items-center justify-center text-zinc-400 shrink-0">
                                    <Shield size={18} />
                                </div>
                                <span className="text-base">No Obligation</span>
                            </div>
                        </div>
                    </div>

                    {/* Right Side: Plan */}
                    <div className="bg-black/40 border border-zinc-800 rounded-2xl p-8">
                         <h4 className="text-sm font-bold text-white uppercase tracking-widest mb-8 opacity-90">
                            Here is the plan for our call:
                        </h4>
                        <div className="space-y-8 text-left">
                            <div className="flex gap-4">
                                <div className="w-8 h-8 rounded-lg bg-red-500/10 flex items-center justify-center shrink-0 border border-red-500/20 text-red-500 mt-1">
                                    <Target size={16} />
                                </div>
                                <div>
                                    <h5 className="text-white font-bold text-base mb-1">The Audit</h5>
                                    <p className="text-zinc-400 text-sm leading-relaxed">We calculate exactly how much revenue you are losing to missed calls right now.</p>
                                </div>
                            </div>
                            <div className="flex gap-4">
                                <div className="w-8 h-8 rounded-lg bg-blue-500/10 flex items-center justify-center shrink-0 border border-blue-500/20 text-blue-500 mt-1">
                                    <Cpu size={16} />
                                </div>
                                <div>
                                    <h5 className="text-white font-bold text-base mb-1">The Build</h5>
                                    <p className="text-zinc-400 text-sm leading-relaxed">You hear a live demo of a custom AI agent handling a roofing lead.</p>
                                </div>
                            </div>
                            <div className="flex gap-4">
                                <div className="w-8 h-8 rounded-lg bg-green-500/10 flex items-center justify-center shrink-0 border border-green-500/20 text-green-500 mt-1">
                                    <Map size={16} />
                                </div>
                                <div>
                                    <h5 className="text-white font-bold text-base mb-1">The Handoff</h5>
                                    <p className="text-zinc-400 text-sm leading-relaxed">You get a launch timeline to automate your front desk completely.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom: Action */}
                <div className="flex flex-col items-center justify-center gap-4 pt-8 border-t border-zinc-800/50">
                    <button 
                        data-cal-namespace="15min"
                        data-cal-link="talescouto/15min"
                        data-cal-config='{"layout":"month_view"}'
                        className="w-full md:w-auto min-w-[320px] bg-[#FF5500] hover:bg-[#ff661a] text-white font-bold py-5 px-8 rounded-xl transition-all flex items-center justify-center gap-3 group shadow-lg shadow-orange-900/20 transform hover:-translate-y-0.5"
                    >
                        <span className="text-lg tracking-tight">Fix My Missed Calls</span>
                        <ArrowRight size={22} className="group-hover:translate-x-1 transition-transform opacity-80" />
                    </button>
                    <div className="flex items-center gap-2 text-zinc-500 text-xs font-medium tracking-wide">
                        <span>🔒</span> No credit card required • Zero obligation
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookingWidget;
